exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width:575px){.select-wrapper[data-v-5b5ed363] select{font-size:body-font-size-md}}", ""]);

